<template>
    <div class="writeWork">
        <div class="top">
            修改工单类型
        </div>
        <div class="main">
            <el-form :model="form" :rules="workSubmitRules" ref="workSubmitForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="工单分类:" prop="parentQaTypeName">
                    <!-- <el-input v-model="form.parentQaTypeName"></el-input> -->
                    <el-select disabled  v-model="updataForm.parentQaTypeName" placeholder="工单类型选择">
                        <el-option v-for="(item,index) in workCutList" :key="index" :label="item.parentQaTypeName" :value="item.parentTypeId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工单类型:" prop="qaTypeName">
                    <el-input v-model="updataForm.qaTypeName"></el-input>
                    <!-- <el-select v-model="form.qaTypeName" placeholder="入驻工单问题">
                        <el-option v-for="(item,index) in workTypeList" :key="index" :label="item.qaTypeName" :value="item.qaTypeId"></el-option>
                    </el-select> -->
                </el-form-item>
                <el-form-item label="问题描述:" prop="qaTypeDesc">
                    <el-input type="textarea" v-model="updataForm.qaTypeDesc" resize="none"  maxlength="500" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="是否展示:" prop="status">
                    <el-switch v-model="updataForm.status" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item label="是否强提醒:" prop="mandatoryTip">
                   <el-switch v-model="updataForm.mandatoryTip" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="submit">提交</el-button>
                    <el-button type="info" size="mini" @click="cancel">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import api from "plus/api";
export default {
    data() {
        return {
          updataId: null,
          updataForm: {},
          form: {
            show: true,//是否展示
            alter: true,//是否强提醒
            qaTypeName: '',//工单类型
            qaTypeDesc: '',
            parentTypeId: '',//工单分类
          },
          workCutList: [],//工单分类
            workTypeList:[],//工单分类
            workSubmitRules:{
            }
        }
    },
    created() {
        this.updataId=this.$route.params.id
        this.getUpdataData()
        this.getType()
    },
    watch:{
    },
    methods: {
        // 提交
        submit(){
          // ;
            let params = {
                id: Number(this.updataForm.id),
                isMandatoryTip:Number(this.updataForm.mandatoryTip),
                qaTypeDesc:this.updataForm.qaTypeDesc,
                qaTypeName:this.updataForm.qaTypeName,
                status:Number(this.updataForm.status)
            }
            ;
            api.privilege.updataSetting(params).then(res=>{
                this.$message({
                    type:'success',
                    message:'修改成功'
                })
            })
        },
        // 获取要修改的数据
        getUpdataData(){
            let params = {
                id:this.updataId
            }
            api.privilege.getSettingDetail(params).then(res=>{
                this.updataForm = res.data.data
                this.updataForm.status = Boolean(this.updataForm.status)
            })
        },
        //工单分类获取工单类型
        changeType(val){
            let filters = {
                id:val
            }
            api.dropDownList.getWorkType(filters).then(res=> {
              this.workTypeList = res.data.data
              // ;
              // ;
            })
        },
        submitForm(){
          ;
        },
        cancel(){
            this.reset()
        },
        reset(){
            this.$refs.workSubmitForm.resetFields();
            this.form.show=true;
            this.form.alter=true;
        },
        getType(){
            // 获取下拉分类
            api.dropDownList.getWorkCut().then(res=>{
                this.workCutList = res.data.data
            })
        }
    },
}
</script>
<style lang="less" scoped>
.el-select {
    width: 100%;
}
.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

}
/deep/input.el-input__inner {
    width: 388px;
}
/deep/textarea.el-textarea__inner {
    width: 388px;
    height: 150px;
}
.demo-ruleForm{
    width: 100%;
}
.writeWork{
    // display: flex;
    // // justify-content: center;
    // align-items: center;
    // flex-direction: column;
    width: 100%;
    background-color: white;
}
.top{
    width: 100%;
    height: 70px;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #333333;
    line-height: 70px;
}
.top::before{
        margin-left: 14px;
        margin-right: 8px;
        content: "";
        border-left: 4px solid #3572e2;
        height: 16px;
}
.main{
    padding-bottom: 80px;
    width: 488px;
    margin-top: 1px;
}
.tishi{
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #999999;
    line-height: 17px;
    margin-bottom: 10px;
    text-align: center;
}

.avatar-uploader {
    margin-top: 25px;
}
</style>
